import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { DATETIME_FORMAT_DATETIME } from '../../../../../utils/helpers/CommonHelper.jsx';
import dayjs from 'dayjs';
import { Spinner, Tooltip } from '../../../../common/index.jsx';
import DataGrid from '../../../../common/DataGrid/DataGrid.jsx';
import { useGetLogsQuery } from '../../../../../redux/services/logs.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient.jsx';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useServerSideTextFilter } from '../../../../common/DataGrid/filters/useServerSideTextFilter.jsx';
import { useServerSideSelectFilter } from '../../../../common/DataGrid/filters/useServerSideSelectFilter.jsx';
import { useServerSideDateRangeFilter } from '../../../../common/DataGrid/filters/useServerSideDateRangeFilter.jsx';

const LogsTable = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  //pagination
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const [pendingPerPage, setPendingPerPage] = useState(null);

  const [filters, setFilters] = useState({});

  const eventOptions = ['created', 'updated', 'deleted'];
  const causerNameFilter = useServerSideTextFilter(
    'causer_name',
    filters,
    setFilters,
  );
  const objectTypeFilter = useServerSideTextFilter(
    'subject_type',
    filters,
    setFilters,
  );
  const objectIdFilter = useServerSideTextFilter(
    'subject_id',
    filters,
    setFilters,
  );
  const dateRangeFilter = useServerSideDateRangeFilter(
    'date',
    filters,
    setFilters,
  );
  const eventFilter = useServerSideSelectFilter(
    'event',
    filters,
    setFilters,
    eventOptions,
  );
  const effectivePerPage = pendingPerPage ?? perPage;
  const { data, isLoading } = useGetLogsQuery({
    page,
    per_page: effectivePerPage,
    ...filters,
  });

  const [total, setTotal] = useState(0);
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    if (data) {
      setLogs(data.data || []);
      setTotal(data.total || 0);

      if (pendingPerPage !== null) {
        setPerPage(pendingPerPage);
        setPendingPerPage(null);
      }
    }
  }, [data]);

  /*  const customSettings = (row) => {
    return (
      <div style={{ display: 'flex' }}>
        <IconButton
          icon={<UndoOutlined />}
          tooltip={t('Vrátiť zmenu späť')}
          onClick={e => {
            e.stopPropagation();
            undoLogChange(row.id);
          }}
        />
      </div>
    );
  };*/

  const columns = [
    {
      title: t('Dátum'),
      dataIndex: 'created_at',
      render: (created_at) => (
        <Tooltip tooltip={dayjs(created_at).format(DATETIME_FORMAT_DATETIME)}>
          <div>{dayjs(created_at).format(DATETIME_FORMAT_DATETIME)}</div>
        </Tooltip>
      ),
      ...dateRangeFilter,
    },
    {
      title: t('Meno'),
      dataIndex: 'causer_name',
      ...causerNameFilter,
    },
    {
      title: t('Operácia'),
      dataIndex: 'event',
      ...eventFilter,
    },

    {
      title: t('ID objektu'),
      dataIndex: 'subject_id',
      ...objectIdFilter,
    },
    {
      title: t('Objekt'),
      dataIndex: 'subject_type',
      ...objectTypeFilter,
    },
  ];

  return isLoading ? (
    <Spinner />
  ) : (
    <DataGrid
      rowKey={(log) => log.id}
      columns={columns}
      dataSource={logs || []}
      pagination={{
        current: page,
        total,
        pageSize: perPage,
        onChange: (newPage, newPageSize) => {
          if (newPageSize !== perPage) {
            setPendingPerPage(newPageSize);
            setPage(1);
          } else {
            setPage(newPage);
          }
        },

        showSizeChanger: true,
        pageSizeOptions: ['20', '50', '100'],
      }}
      loading={isLoading}
      onRowClick={(log) => navigate(`${routes.cmsLogsDetail}/${log.id}`)}
      onRowDetailClick={(log) => navigate(`${routes.cmsLogsDetail}/${log.id}`)}
      onPreviewClick={(log) => navigate(`${routes.cmsLogsDetail}/${log.id}`)}
      permissionsBasic={'logs'}
      uniqueTableId={'logs-table'}
      resetFiltersCallback={() => {
        setFilters({});
      }}
    />
  );
};

LogsTable.propTypes = {
  columns: PropTypes.array,
};

export default LogsTable;
